import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Wizard from "@/pages/public/Wizard";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import OperacionDetalle from "@/pages/admin/OperacionDetalle";
import Clientes from "@/pages/admin/Clientes";
import Config from "@/pages/admin/Config";
import Usuarios from "@/pages/admin/Usuarios";
import MiCuenta from "@/pages/admin/MiCuenta";
import LegalPage from "@/pages/public/LegalPage";

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) {
    return <div className="min-h-screen flex items-center justify-center text-slate-500">Cargando...</div>;
  }
  if (!user) return <Navigate to="/atm-seguros/login" state={{ from: location }} replace />;
  return children;
}

function RequireAdmin({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/atm-seguros" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/terminos" element={<LegalPage tipo="terminos" />} />
            <Route path="/privacidad" element={<LegalPage tipo="privacidad" />} />
            <Route path="/:paso?" element={<Wizard />} />
            <Route path="/mp/:token" element={<Wizard />} />
            <Route path="/mp/:token/:llave" element={<Wizard />} />
            <Route path="/recuperar/:token" element={<Wizard />} />
            <Route path="/atm-seguros/login" element={<AdminLogin />} />
            <Route path="/atm-seguros" element={<Protected><AdminLayout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="operaciones/:id" element={<OperacionDetalle />} />
              <Route path="clientes" element={<Clientes />} />
              <Route path="config" element={<RequireAdmin><Config /></RequireAdmin>} />
              <Route path="usuarios" element={<RequireAdmin><Usuarios /></RequireAdmin>} />
              <Route path="cuenta" element={<MiCuenta />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" offset="80px" />
      </AuthProvider>
    </div>
  );
}

export default App;
